module.exports = __webpack_public_path__ + "img/ditto-mark-white.67849ed5.svg";